import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import NoResults from '../../components/NoResults/NoResults'
import moment from 'moment'
import { NavigationContext } from '../../context/navigation-context'
import { NotificationManager } from 'react-notifications'
import SearchFilter from '../../components/Filter/SearchFilter'

const ZWS = () => {
  const { TRL_Pack } = useContext(LangContext);
  const { fetchMssqlApi } = useFetch();
  const { setHeaderData } = useContext(NavigationContext);

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [ZWS, setZWS] = useState(null);

  const defaultFilter = {
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    page: 1,
    rowsPerPage: 50,
    warehouseId: null,
    warehouseName: "",
    sortBy: "none",
  };

  const [filter, setFilter] = useState(defaultFilter);

  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    Created: "DESC",
    IssuedOn: "DESC",
    WarehouseFullName: "ASC",
    ToWarehouseOperationFullName: "ASC",
    Comment: "ASC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    getZWS(next.dateTimeRangeFrom, next.dateTimeRangeTo, next.sortBy);
  };

  useEffect(() => {
    const handleResize = () => {
      const height = window.innerHeight;
      setWindowHeight(height);

      const visibleRows = Math.floor((height - 350) / 40);

      setFilter((prev) => ({
        ...prev,
        rowsPerPage: visibleRows > 50 ? 50 : visibleRows,
      }));
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getZWS = (
    fromDate = filter.dateTimeRangeFrom,
    toDate = filter.dateTimeRangeTo,
    sortBy = filter.sortBy
  ) => {
    if (!moment(fromDate).isValid() || !moment(toDate).isValid()) {
      NotificationManager.error("Wybierz poprawną datę");
      return;
    }

    fetchMssqlApi(
      "zw-zws",
      {
        method: "POST",
        hideNotification: true,
        data: {
          clientId: sessionStorage.getItem("clientId"),
          fromCreateDateTime: fromDate,
          toCreateDateTime: toDate,
          sortBy: sortBy,
        },
      },
      (response) => {
        setZWS(response);
      }
    );
  };

  useEffect(() => {
    getZWS();
    setHeaderData({ text: TRL_Pack.zw.zws });
  }, []);

  useEffect(() => {
    localStorage.setItem("zwsFilter", JSON.stringify(filter));
  }, [filter]);

  const getUI = () => {
    if (!ZWS) return null;

  const filtered = ZWS.filter((t) => {
    if (
      filter.warehouseName &&
      !t.WarehouseFullName?.toLowerCase().includes(filter.warehouseName.toLowerCase())
    ) {
      return false;
    }

    return true;
  });
  
    return (
      <div>
        <SearchFilter
          filterName="zws"
          defaultFilter={defaultFilter}
          onFilterChange={(f) => setFilter((prev) => ({ ...prev, ...f }))}
          onSettingsChange={(s) =>
            setSettingsFilter((prev) => ({ ...prev, ...s }))
          }
          search={() => getZWS(filter.dateTimeRangeFrom, filter.dateTimeRangeTo, filter.sortBy)}
          loading={false}
          totalCount={filtered.slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage).length}
          dataList={ZWS}
          forNow
        />

        <div className="card">
          <h5 className="card-header">
            <div className="d-flex justify-content-between">
              <div></div>
              <Link
                to={`/zw/0`}
                className="btn text-nowrap btn-outline-secondary mt-1 mb-1"
              >
                <i className="fas fa-plus" />
              </Link>
            </div>
          </h5>

          <div
            className="overflow-auto custom-scroll"
            style={{
              maxHeight: `${windowHeight - 216}px`,
              overflowY: "auto",
            }}
          >
            {filtered.length ? (
              <table className="table table-striped">
                <thead>
                  <tr className="text-center headers-color">
                    <td
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleHeaderSort("Created")}
                    >
                      Nr <br />Czas zapisu, Źródło{arrow("Created")}
                    </td>
                    <td
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleHeaderSort("IssuedOn")}
                    >
                      Data / czas wystawienia{arrow("IssuedOn")}
                    </td>
                    <td
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleHeaderSort("WarehouseFullName")}
                    >
                      Magazyn{arrow("WarehouseFullName")}
                    </td>
                    <td
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleHeaderSort("ToWarehouseOperationFullName")}
                    >
                      Dokument powiązany{arrow("ToWarehouseOperationFullName")}
                    </td>
                    <td
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleHeaderSort("Comment")}
                    >
                      Komentarz{arrow("Comment")}
                    </td>
                  </tr>
                </thead>

                <tbody>
                  {filtered
                    .slice(
                      (filter.page - 1) * rowsPerPage,
                      filter.page * rowsPerPage
                    )
                    .map((entry, idx) => (
                      <tr key={idx}>
                        <td>
                          <div className="d-flex flex-column justify-content-center align-items-center">
                            <div className="text-nowrap">
                              <Link
                                to={`/zw/${entry.WarehouseOperationId}`}
                                className="btn btn-sm btn-outline-primary"
                              >
                                ZW {entry.WarehouseOperationId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}
                              </Link>
                            </div>
                            <div className="text-nowrap">{entry.Created}</div>
                          </div>
                        </td>

                        <td className="text-center">{entry.IssuedOn}</td>

                        <td className="text-center">{entry.WarehouseFullName}</td>

                        <td className="text-center">
                          {entry.ToWarehouseOperationId && (
                            <Link
                              to={`/wz/${entry.ToWarehouseOperationId}`}
                              className="btn btn-sm btn-outline-secondary"
                            >
                              WZ {entry.WarehouseOperationId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}
                            </Link>
                          )}
                        </td>

                        <td className="text-center">{entry.Comment}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              <NoResults />
            )}
          </div>
        </div>
      </div>
    );
  };

  return <div>{getUI()}</div>;
};

export default ZWS;